import React, { ReactNode } from 'react';

import { useAppSelector } from 'shared/lib/redux';
import { SeeAllPage, SeeAllHeader } from 'shared/ui/layout';
import { ClassFilter, ProgramsFilter } from 'features/filters';
import {
  AssignmentActionNotificationPopup,
  AssignmentPanel,
} from 'features/assignment-panel';

export type PageWrapperProps = {
  children: ReactNode;
  showClassFilter: boolean;
  showProgramsFilter: boolean;
};

export const PageWrapper = ({
  children,
  showClassFilter,
  showProgramsFilter,
}: PageWrapperProps) => {
  const {
    isAssignmentPanelOpened,
    isAssignmentActionNotificationActive,
    editingAssignment,
  } = useAppSelector((state) => state.assignmentPanel);

  return (
    <SeeAllPage>
      <SeeAllHeader title="Scheduled Assignments">
        <div className="d-block d-sm-flex flex-fill d-lg-block align-items-center justify-content-start">
          {showClassFilter && <ClassFilter />}
          {showProgramsFilter && <ProgramsFilter />}
        </div>
      </SeeAllHeader>
      <div className="col-md-12 col-lg-9 rhythm-mt-2">{children}</div>
      {isAssignmentPanelOpened && editingAssignment && <AssignmentPanel />}
      {isAssignmentActionNotificationActive && (
        <AssignmentActionNotificationPopup />
      )}
    </SeeAllPage>
  );
};
